module.exports = __webpack_public_path__ + "static/media/Tender_Extension.95cbaff6.pdf";